<template>
	<div class="fp_qty">
		<span class="fp_qty__dec" @click="decrement"></span>
		<input class="fp_qty__input" type="number" :value="value" @input="updateValue" :min="min">
		<span class="fp_qty__inc" @click="increment"></span>
	</div>
</template>

<script>
	export default {
		props: {
			value: {
				type: Number
			},
			min: {
				type: Number,
				default: 0
			}
		},
		data: function() {
			return {
			}
		},
		methods: {
			updateValue: function(event) {
				this.$emit('input', parseInt(event.target.value));
			},
			increment() {
				var val = parseInt(this.value) + 1;
				this.$emit('input', val);
			},
			decrement() {
				var val = parseInt(this.value) - 1;
				if (val <= this.min) {
					val = this.min;
				}
				this.$emit('input', val);
			}
		}
	}
</script>
